/*
 * @Date: 2022-07-04 09:34:54
 * @LastEditors: chuhongguang
 */
import { createStore } from 'vuex';
import createPersistedstate from 'vuex-persistedstate'

import lang from './modules/lang.js';

export default createStore({
  modules: {
    lang
  },
  plugins:[
    createPersistedstate({
      storage: window.sessionStorage,
      reducer(val) {
        const { lang } = val
        return {
          // 缓存指定的state中的数据
          lang
        }
      }
    })
  ]
});
